import { getRequest, patchRequest, postRequest, putRequest } from 'sync/request';
import { InvitationContext, OrganizationContext, UserContext } from 'sync/request.types';
import type {
  InvitationResponsePayload,
  UpdateUserMfaPayload,
  UpdateUserPayload,
  UpdateUserResponse,
  User,
  UserConfirmMfaPayload,
  UserInvitationList,
  UserMfaResponse,
} from './user-service.types';

/**
 * Return details for a specified user.
 */
export function getUser({ userId }: UserContext) {
  return getRequest<User>(`/users/${userId}`);
}

/**
 * Update details for a specified user, also update user password.
 */
export function updateUser({ userId }: UserContext, data: UpdateUserPayload) {
  return patchRequest<UpdateUserResponse>(`/users/${userId}`, { data });
}

/**
 * Toggle MFA for a specified user.
 */
export function setUserMfa({ userId }: UserContext, data: UpdateUserMfaPayload) {
  return putRequest<UserMfaResponse>(`/users/${userId}/mfa`, { data });
}

/**
 * Confirm MFA sync when enabled for a user.
 */
export function confirmUserMfa({ userId }: UserContext, data: UserConfirmMfaPayload) {
  return postRequest<{}>(`/users/${userId}/mfa/confirmation`, { data });
}

/**
 * Return pending invitations of the current user
 */
export function listUserInvitations() {
  return getRequest<UserInvitationList>(`/invitations`);
}

/**
 * Used to accept/decline invitations
 */
export function respondToUserInvitation({ invitationId }: InvitationContext, data: InvitationResponsePayload) {
  return putRequest<{}>(`/invitations/${invitationId}`, { data });
}

/**
 * Accepts terms of service
 */
export function acceptUserTermsOfService({ organizationId, userId }: UserContext & OrganizationContext) {
  return putRequest<{}>(`/v2/organizations/${organizationId}/users/${userId}/preferences/tos`);
}
